import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const TopRow = styled.div`
  display: flex;
  align-items: stretch;
  padding-bottom: 0.5rem;
`
const Container = styled.th`
  background-color: #2a3230;
  vertical-align: top;
  padding: 0.5rem 1rem 0.5rem 0.5rem;
`
const Title = styled.h4`
  flex: auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0;
  color: ${(props) => props.theme.colours.text.secondary};
`
const SortContainer = styled.div`
  flex: none;
  display: flex;
  align-items: center;
`
const FilterContainer = styled.div`
  width: 100%;
  display: flex;
`

/** TableHeader designed for interactive tables with
 * optional sorting and filter UI controls. */
const TableHeader = ({ children, filterControl, sortControl, title }) => {
  return (
    <Container title={title}>
      <TopRow>
        <Title>{children}</Title>
        {sortControl && <SortContainer>{sortControl}</SortContainer>}
      </TopRow>
      {filterControl && <FilterContainer>{filterControl}</FilterContainer>}
    </Container>
  )
}

TableHeader.propTypes = {
  // The "title" content
  children: PropTypes.any,
  // A rendered react component, e.g. <MyDateFilter />
  filterControl: PropTypes.element,
  // A rendered react component, e.g. <MyDateSorter />
  sortControl: PropTypes.element,
  title: PropTypes.any,
}

export default TableHeader
